/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_723b6120"]'><cube-button outline disabled>outline</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_723b6120"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_723b6120"}
  /** script content **/
  require("./btn-outline-disabled.mpx.js?isComponent&outputPath=components%2Fbtn-outline-disabled723b6120%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./btn-outline-disabled.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fbtn-outline-disabled723b6120%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_723b6120"],
    ctorType: "component",
    outputPath: "components/btn-outline-disabled723b6120/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>